export default __webpack_public_path__ + "static/media/img3.42112d5e.PNG";